/**
 * @file employment.js
 * @author Jake Stark
 * @desc PostGradIndicators report plugin

*/

/**
 * @module employement
 * @desc Employment report plugin
 */

define('plugins/employment',["underscore",
        "models", "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/employment_hourlyWage_table.html", "text!plugins/templates/employment_annualWage_table.html", "text!plugins/templates/employment_graduatesWorking_table.html!strip", "text!plugins/templates/employment_moreInfo_table.html", "cardboard/pluginPieces"
    ],
    function (_, SLEDSModels, CardboardModels, CardboardCollections, Util,
        hourlyTemplate, annualTemplate, graduatesWorkingTemplate,  moreInfoTemplate, PluginPieces) {

        console.log("MODULE: employment");

        var exports = {

            options: {
                dynamicTextDomain: "employment",
                noMapSearch: true,
                orgDetailPane: false,
                forcedSummaryFilters: ["employmentCOHORTID", "employmentAward"],
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                title: "Graduates Working",
                //titlePath: "collegeEnrollment.contents.0",
                explanationText: '<p>This report shows the number and percent of college graduates who continued their education in Minnesota after graduation or were found in Minnesota. Employed graduates are those found working in Minnesota after college graduation. Graduates not found to be enrolled in additional education or working in Minnesota but were found in participating in a workforce training program, incarcerated,  or licensed to work in Minnesota are included in the "Other" count. Students in the "Unknown" category may be working in another state, enlisted in military service, be self-employed or working in other organizations not subject to state reporting, or not engaged in the labor force.</p>',
                //explanationTextPath: "collegeEnrollment.contents.1",
                openByDefault: true,
                views: [
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "dataSets.graduatesWorking.data",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        // xAxisLabelPath: "subjects.label",
                        unitString: "%",
                        showLegend: true,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "type",
                                dataPath: "orgs",
                                displayNamePath: "name",
                                valuePath: "percent"
                            }
                        ],
                       errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: graduatesWorkingTemplate,
                        dataSourceName: "data",
                    }
                ]
            },
            {
                    title: "Hourly Wage Trends",

                    explanationText: "<p>This report shows the median hourly wages two and three years after graduation for Minnesota college graduates.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>Median Hourly Wages of Minnesota College Graduates </h5>" + "<p>Note: Among all graduates with reported wages one or two years after graduation, half earned more and half earned less than this median hourly wage. Hourly rates lower than $6 are excluded from the calculation because they represent training wages paid to employees under 20 years old.</p>",

                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "dataSets.hourlyWageTrends.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,
                            //convertDataHashToArray: true,

                            // DISPLAY
                            //xAxisLabelPath: "metric[1].name",
                            unitString: "",
                            unitPreString: "$",
                            unitDec: 2,
                            showLegend: true,
                            yAxisMax: 35,
                            yAxisTickInterval: 5,
                            dataLabels: true,
                            //colorByPoint: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "chartMetrics",
                                    valuePath: "number",
                                    seriesDisplayNamePath: "award",
                                    displayNamePath: "name",

                                },
                                {
                                    dataPath: "chartMetrics",
                                    valuePath: "number",
                                    seriesDisplayNamePath: "award",
                                    displayNamePath: "name",

                                }
                            ],
                            //    //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: hourlyTemplate,
                            dataSourceName: "data",
                            dataSetPath: "dataSets.hourlyWageTrends",
                            //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Annual Wages and Employment",
                    //titlePath: "highSchoolAcademics.content.1",
                    explanationText: "<p>This report shows the percent of college graduates found employed in Minnesota and their annual wages two years after graduation. This report also shows the percent of college graduates found employed full-time and the annual median wages of full-time employed workers among college graduates two-years after graduation. Graduates who earned more than one type of award in the same academic year were classified according to the highest type of award obtained. Graduates not found to be employed in Minnesota may be working in another state, enlisted in military service, be self-employed or working in other organizations not subject to state reporting, or not engaged in the labor force.</p>",
                    //explanationTextPath: "highSchoolAcademics.content.2",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>Annual Employment and Wages of Minnesota College Graduates in the Second Year After Graduation</h5>" + "Note: This measure underestimates the employment rate because graduates employed at federal agencies, self-employed, or employed in other states are not included in Minnesota wage records.",
                            //templatePath: "highSchoolAccountability.content"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "dataSets.annualWagesAndEmployment.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "",
                            unitPreString: "$",

                            showLegend: true,
                            yAxisMax: 70000,
                            yAxisTickInterval: 5000,
                            dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "chartMetrics",
                                    valuePath: "number",
                                    seriesDisplayNamePath: "award",
                                    displayNamePath: "name",

                                },
                                {
                                    dataPath: "chartMetrics",
                                    valuePath: "number",
                                    seriesDisplayNamePath: "award",
                                    displayNamePath: "name",

                                }
                            ],
                            //                 //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: annualTemplate,
                            dataSourceName: "data",
                            dataSetPath: "dataSets.annualWagesAndEmployment",
                            //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                
                {
                    title: "More Information",
                    //titlePath: "highSchoolAcademics.content.1",
                    //explanationText: "<p>This report shows the two year after graduation employment and wage outcomes of Minnesota college graduates. Graduates who earned more than one degree in the same academic year were classified according to the highest degree obtained.</p>",
                    //explanationTextPath: "highSchoolAcademics.content.2",
                    openByDefault: false,
                    views: [{
                        type: "template",
                        //template: moreInfoTemplate,
                        template: "<p>For more employment and wage data on Minnesota college graduates – including field of study, top industries and regions of employment, and annual employment and wage data, please visit the <A HREF='http://mn.gov/deed/data/data-tools/graduate-employment-outcomes' target='_blank'>Graduate Employment Outcomes tool</a>.</p><p>The Graduate Employment Outcomes tool helps Minnesota’s students, job seekers, career counselors, educators, and policy makers better understand the connections between postsecondary education choices and job outcomes. </p><p>The tool displays key aspects of employment, including:</p><ul><li>Wages: What hourly pay can a graduate expect 2, 3, 5, and 8 years after graduation?</li><li>Wage growth trends: How fast did wages grow over time?</li><li>Industries of employment: What types of businesses employed recent graduates?</li><li>Employment prospects: What share of graduates found jobs in the state?</li><li>Year-round employment and wages: What share of graduates were employed without interruption during the second, third and fourth year after graduation? And what were their wages?</li></ul> <p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031886&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all colleges or systems and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.forMoreInformation"
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_employment_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_employmentcohortid.fex",
                    enabled: true
                },
                filters2: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_employmentaward.fex",
                    enabled: true
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_employment.fex",
                    yearPath: "employmentCOHORTID",
                    defaultParams: {
                        orgId: 999999000,
                        employmentCOHORTID: 2012,
                        employmentAward: "All Awards"
                    },
                    enabled: true
                }
            }
        };

        return exports;
    });
